import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button', 'popup']

  connect() {
    this.buttonTarget.setAttribute('data-action', 'click->dropdown#toggle click@window->dropdown#hide');
    this.buttonTarget.setAttribute('aria-haspopup', true);
    this.buttonTarget.setAttribute('aria-expanded', false);
  }

  toggle(event) {
    event.preventDefault();

    if (this.buttonTarget.getAttribute('aria-expanded') == "false") {
      this.show();
    } else {
      this.hide(null);
    }
  }

  show() {
    this.buttonTarget.setAttribute('aria-expanded', 'true');
    this.popupTarget.classList.remove('hidden');
  }

  hide(event) {
    // Prevent clicks within the popup from hiding it
    if (event && (this.popupTarget.contains(event.target) || this.buttonTarget.contains(event.target))) {
      return;
    }

    this.buttonTarget.setAttribute('aria-expanded', 'false');
    this.popupTarget.classList.add('hidden');
  }
}
